<template>
  <div>
    <NBar title="设备参数"/>
    <nut-cell title="提示参数" :desc="option" @click.native="showPicker = true" style="margin-top: 10px;"/>
    <nut-picker
      :is-visible="showPicker"
      :list-data="listData"
      :default-value-data="defaultListData"
      @close="showPicker = false"
      @confirm="confirm"
    ></nut-picker>
    <nut-cell title="模式开关">
      <div slot="desc">
        <nut-switch></nut-switch>
      </div>
    </nut-cell>
    <nut-buttongroup style="position: absolute;bottom: 0;">
      <nut-button type="light" style="flex: 1;color: #589FF5;">刷新</nut-button>
      <nut-button style="background: #589FF5;flex: 3;">保存设置</nut-button>
    </nut-buttongroup>
  </div>
</template>

<script>
/**
 * 设备参数
 */
export default {
  name: 'DeviceParameter',
  data () {
    return {
      option: '请选择',
      showPicker: false,
      listData: [[
        {
          label: 0,
          value: '待机'
        },
        {
          label: 1,
          value: '模式1',
        },
        {
          label: 2,
          value: '模式2',
        },
        {
          label: 3,
          value: '模式3',
        },
        {
          label: 4,
          value: '模式4',
        },
        {
          label: 5,
          value: '模式5',
        },
        {
          label: 6,
          value: '模式6',
        }
      ]],
      defaultListData: null
    }
  },
  mounted () {
    this.defaultListData = [this.listData[0][2]]
  },
  methods: {
    confirm (chooseData) {
      this.option = `${chooseData[0].value}`
    }
  }
}
</script>

<style scoped>
  >>> .nut-switch.nut-switch-active .nut-switch-btn {
    background-color: #1a87ff;
  }

  >>> .nut-switch.nut-switch-active {
    border-color: #1a87ff;
  }
</style>



// WEBPACK FOOTER //
// src/components/device/home/DeviceParameter.vue